import React from 'react';

export interface WizardContextProps {
  currentStepNumber: number;
  next: () => void;
  prev: () => void;
  goto: (step: number | string) => void;
}

export const WizardContext: React.Context<WizardContextProps> =
  React.createContext({
    currentStepNumber: 0,
    next: () => {},
    prev: () => {},
    goto: (step: number | string) => {},
  });
